export default __webpack_public_path__ + "static/media/OhSnap_159x150.16d1dfe5.png";